import React, { useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Box, Typography, Divider } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import './BookingSuccessView.scss';

const EventUpcomingIcon = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.href =
      'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  return (
    <span
      className="material-symbols-outlined fontWhite margr8 text-100 margt70"
      style={{
        verticalAlign: 'middle',
        fontSize: '70px',
      }}
    >
      event_upcoming
    </span>
  );
};

const LoginForm = props => {
  const { initialValues, onSubmit, loading, languageData, onRegister } = props;
  return (
    <FlexContainer className={'flex-column margtb20'}>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {({ isSubmitting }) => (
          <Form className="width100" style={{ maxWidth: '400px' }}>
            <FlexContainer className="flex-column align-items-center justify-center text-center margt10 padlr30 row-gap-1">
              <EventUpcomingIcon />
              <Label
                className={
                  'text-26 margtb20   align-items-center justify-center text-center'
                }
              >
                {languageData === 'EN' ? (
                  <>
                    Thank you for <br /> booking with us!
                  </>
                ) : (
                  'Gracias por reservar con nosotros!'
                )}
              </Label>
              <Label className="text-16 text-center width100 fontWhite">
                {languageData === 'EN' ? (
                  <React.Fragment>Get ready to experience a</React.Fragment>
                ) : (
                  <React.Fragment>
                    Prepárate para experimentar un
                  </React.Fragment>
                )}
              </Label>

              <Label className="text-16 text-center width100 fontWhite">
                {languageData === 'EN'
                  ? 'welcoming work environment where'
                  : 'ambiente laboral acogedor donde'}
              </Label>

              <Label className="text-16 text-center width100 fontWhite">
                {languageData === 'EN'
                  ? 'creativity and connection meet in'
                  : 'la creatividad y la conexión se encuentran en'}
              </Label>

              <Label className="text-16 text-center width100 fontWhite">
                {languageData === 'EN'
                  ? 'the heart of Mexico City'
                  : 'el corazón de la Ciudad de México'}
              </Label>
            </FlexContainer>
            <Button
              className={'bgGradientSignUpPurple '}
              type="submit"
              fullWidth
              sx={{
                mt: '30px',
                py: 0.8,
                color: 'white',
                borderRadius: '10px',
                textTransform: 'none',
                transition: 'all 0.2s ease',
                fontSize: '20px',
                '&:hover': {
                  boxShadow: '0 6px 16px rgba(248, 87, 166, 0.5)',
                  transform: 'translateY(-1px)',
                },
                '&:disabled': {
                  opacity: 0.7,
                },
              }}
              disabled={loading || isSubmitting}
            >
              {loading
                ? languageData === 'EN'
                  ? 'Loading...'
                  : 'Cargando...'
                : languageData === 'EN'
                  ? 'Back to home Page'
                  : 'Volver a la página de inicio'}
            </Button>
          </Form>
        )}
      </Formik>
    </FlexContainer>
  );
};

const BookingSuccesView = props => {
  const { initialValues, onSubmit, loading, onBack, onRegister, languageData } =
    props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FlexContainer className="BookingSuccesView flex-column padlr10 justify-start items-center  bgGradientBlue fontWhite">
      <FlexContainer className={'flex-column padlr10 margb30 height-550px'}>
        <LoginForm
          languageData={languageData}
          onBack={onBack}
          initialValues={initialValues}
          onSubmit={onSubmit}
          loading={loading}
          onRegister={onRegister}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default BookingSuccesView;
